import { selectAgentV2ActiveCitationId } from '@/agent-v2/references/store/selectors'
import { useDraftWorkspace } from '@/drafting/workspace/hooks/useDraftWorkspace'
import { useAppSelector } from '@/store/store-hooks'

/** Which citation to highlight in the conversation. */
export function useConversationActiveCitationId(): string | null {
  const { draftArtifactVersionId } = useDraftWorkspace()
  const activeCitationId = useAppSelector(selectAgentV2ActiveCitationId)

  // A citation is only highlighted where its source can be read alongside it, and the workspace shows
  // the conversation and the source as two tabs, never together.
  return draftArtifactVersionId ? null : activeCitationId
}
